import { createTheme } from '@mui/material';
import { capitalDesignTokens, capitalMuiTheme } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const storiesAppTheme = createTheme(capitalMuiTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: { fontSize: '14px' },
        sizeSmall: { fontSize: '14px' },
        sizeMedium: { fontSize: '14px' },
        sizeLarge: { fontSize: '14px' },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { fontSize: '16px' },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& textarea:hover, & input:hover': { border: 'none' },
          '& input:focus, & textarea:focus': { border: 'unset', outline: 'unset' },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: '1rem',
          color: capitalDesignTokens.semanticColors.foreground.primary,
        },
        sizeLarge: {
          fontSize: '1.25rem',
          fontWeight: foundations.typography.fontWeight.normal,
          '& input:focus': { padding: '8px' },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-fontSizeMedium': { fontSize: '1.5rem' },
          '& input': { marginRight: '-24px', marginTop: '-8px' },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-fontSizeMedium': { marginRight: '0px' },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': { marginRight: '0px' },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            transform: 'translateX(25px)!important',
          },
          '&.Mui-checked + .MuiSwitch-track': {
            opacity: 1,
          },
        },
      },
    },
  },
});
